module.exports = __webpack_public_path__ + "static/phone-2-2a3b5e664c8e543114151a9821665dee.svg";